/*
 * ShiftTable Messages
 *
 * This contains all the text for the ShiftTable component.
 */

import { defineMessages } from 'react-intl';

export const scope =
  'src.pages.ProjectDetailsPage.components.JobDetails.components.TransferForm.components.ShiftsTable';

export default defineMessages({
  dateColumnLabel: {
    id: `${scope}.dateColumnLabel`,
    defaultMessage: 'Date',
  },
  shiftColumnLabel: {
    id: `${scope}.shiftColumnLabel`,
    defaultMessage: 'Shift Timeframe',
  },
  requiredColumnLabel: {
    id: `${scope}.requiredColumnLabel`,
    defaultMessage: 'Required',
  },
});
